import interceptor from '../restServiceInterceptor';
import i18next from 'i18next';

export interface InvoiceTextTemplate {
    id: string;
    name: string;
    template: string;
    version: number;
    everUsed?: boolean;
    builtIn?: boolean;
}

export const getInvoiceTextTemplates = async (): Promise<InvoiceTextTemplate[]> => {
    const items: InvoiceTextTemplate[] = await interceptor.get('/client-service/invoice-text-templates');
    if (!Array.isArray(items)) throw new Error(i18next.t('invoiceTextTemplates.loadError'));
    return items;
};

export const saveInvoiceTextTemplate = (item: InvoiceTextTemplate): Promise<InvoiceTextTemplate> =>
    item.id
        ? interceptor.put(`/client-service/admin/invoice-text-templates/${item.id}`, item)
        : interceptor.post('/client-service/admin/invoice-text-templates', item);

export interface MissingContractClient { id: number; companyName: string; eik: string | null; }

export const getMissingContractClients = async (id: string): Promise<MissingContractClient[]> => {
    const items: MissingContractClient[] = await interceptor.get(`/client-service/admin/invoice-text-templates/${id}/missing-contracts`);
    if (!Array.isArray(items)) throw new Error(i18next.t('invoiceTextTemplates.checkError'));
    return items;
};

export const deleteInvoiceTextTemplate = (id: string): Promise<void> =>
    interceptor.delete(`/client-service/admin/invoice-text-templates/${id}`);
